<template>
  <div class="m1downloadBox">
    <!-- <img class="m1_close" src="./connect/img/M1/close.png"></img> -->
    <div class="m1_title">{{ $t('MacDownload.title') }}</div>
    <div class="m1_text1">{{ $t('MacDownload.text1') }}</div>
    <div v-if="isIntel === 2">
        <div class="m1_text2-intel">{{ $t('MacDownload.text2-intel') }}</div>
        <div class="flex">
            <div class="m1_Intel-intel" @click="downloadByUrl('MeiXin_Mac_Link')">{{ $t('MacDownload.macIntel') }}</div>
        </div>
        <div class="flex" style="margin-top: 12px">
            <div class="m1_Apple-intel" @click="downloadByUrl('MeiXin_MacM1_Link')">{{ $t('MacDownload.macM1') }}</div>
        </div>
    </div>
    <div v-if="isIntel === 1">
        <div class="m1_text2-intel">{{ $t('MacDownload.text2-apple') }}</div>
        <div class="flex">
            <div class="m1_Intel-intel" @click="downloadByUrl('MeiXin_MacM1_Link')">{{ $t('MacDownload.macM1') }}</div>
        </div>
        <div class="flex" style="margin-top: 12px">
            <div class="m1_Apple-intel" @click="downloadByUrl('MeiXin_Mac_Link')">{{ $t('MacDownload.macIntel') }}</div>
        </div>
    </div>
    <div v-if="isIntel === 3">
        <div class="m1_text2">{{ $t('MacDownload.text2') }}</div>
        <div class="m1_text3">
            <span class="about-left">{{ $t('MacDownload.aboutLeft') }}</span>
            <span class="bold about">{{ $t('MacDownload.about') }}</span>
            <span class="about-right">{{ $t('MacDownload.aboutRight') }}</span>
        </div>
        <div class="m1_text3">
            <span class="gaishu-left">{{ $t('MacDownload.gaishuLeft') }}</span>
            <span class="bold gaishu">{{ $t('MacDownload.gaishu') }}</span>
            <span class="chuliqi-left">{{ $t('MacDownload.chuliqiLeft') }}</span>
            <span class="bold chuliqi">{{ $t('MacDownload.chuliqi') }}</span>
            <span class="type-left">{{ $t('MacDownload.typeLeft') }}</span>
            <span class="bold type">{{ $t('MacDownload.type') }}</span>
            <span class="intel-left">{{ $t('MacDownload.intelLeft') }}</span>
            <span class="bold intel">{{ $t('MacDownload.intel') }}</span>
            <span class="apple-left">{{ $t('MacDownload.appleLeft') }}</span>
            <span class="bold apple">{{ $t('MacDownload.apple') }}</span>
            <span class="apple-right">{{ $t('MacDownload.appleRight') }}</span>
        </div>
        <div class="m1_imgList">
            <img class="m1_img1" @click="showImg($t('MacDownload.img1'))" :src="$t('MacDownload.img1')" alt="">
            <img class="m1_img2" @click="showImg($t('MacDownload.img2'))" :src="$t('MacDownload.img2')" alt="">
            <img class="m1_img3" @click="showImg($t('MacDownload.img3'))" :src="$t('MacDownload.img3')" alt="">
        </div>
        <div class="m1_imgView" :style="{'display': isShowImg ? 'flex' : 'none'}" @click="hideImg">
            <img :src="showImgUrl" alt="">
        </div>
        <div class="m1_text4">{{ $t('MacDownload.text4') }}</div>
        <div class="m1_btnList">
            <div class="m1_Intel" @click="downloadByUrl('MeiXin_Mac_Link')">{{ $t('MacDownload.macIntel') }}</div>
            <div class="m1_Apple" @click="downloadByUrl('MeiXin_MacM1_Link')">{{ $t('MacDownload.macM1') }}</div>
        </div>
    </div>
</div>
</template>
<script>
import { is4aLogin } from '@/mx-service/libs/utils';
import device from '@/mx-service/libs/utils/device'

export default {
  data(){
    return {
      showImgUrl: '',
      isShowImg: false,
      isIntel: false
    }
  },
  props: {
    downloadList: {
      type: Array,
      required: true
    }
  },
  methods:{
    showImg(e){
      this.showImgUrl = e
      this.isShowImg = true
    },
    hideImg(){
      this.isShowImg = false
    },
    async downloadByUrl(e){
        const status = await is4aLogin(e, true)
        if(!status) return
        const data = this.downloadList.filter(item => item.paramId === e)[0]
        window.location.href = data.paramValue;
        this.hideImg()
    }
  },
  mounted(){
    console.log(1231231231, device.isIntelMac())
    this.isIntel = device.isIntelMac()
  },
};
</script>

<style lang="less">
.flex {
    display: flex;
    justify-content: center;
    align-items: center;
}
.m1downloadBox {
    width: 620px;
    position: relative;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.m1_title {
    font-size: 18px;
    font-weight: 600;
    color: #1D2129;
    line-height: 25px;
    width: 100%;
    text-align: center;
}
.m1_text1 {
    font-size: 12px;
    color: #696969;
    line-height: 20px;
    margin-top: 16px;
    text-align: left;
}
.m1_text2-intel {
    font-size: 16px;
    font-weight: 600;
    color: #1D2129;
    margin: 16px 0 40px;
    line-height: 24px;
    text-align: left;
}
.m1_text2 {
    font-size: 16px;
    font-weight: 600;
    color: #1D2129;
    margin: 16px 0;
    line-height: 24px;
    text-align: left;
}
.m1_text3 {
    font-size: 12px;
    color: #696969;
    text-align: left;
    line-height: 20px;
}
.m1_text3 .bold {
    color: #111;
    font-weight: 600;
}
.m1_imgList {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 13px 0 18px 0;
}
.m1_imgList img {
    width: 170px;
    height: 106px;
    cursor: zoom-in;
    border-radius: 8px;
}
.m1_text4 {
    font-size: 12px;
    color: #696969;
    text-align: left;
    line-height: 20px;
}
.m1_btnList {
    margin-top: 30px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.m1_Intel-intel {
    background: linear-gradient(133deg, #00AFFF 0%, #0F5FFF 100%) rgba(0,0,0,0);
    padding: 5px 16px;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 22px;
    border-radius: 6px;
    cursor: pointer;
    text-align: center;
    width: 160px;
    box-sizing: border-box;
}
.m1_Apple-intel {
    font-size: 14px;
    color: #696969;
    line-height: 22px;
    cursor: pointer;
    text-align: center;
    &:hover{
        color: #0F5FFF;
    }
}
.m1_Intel {
    background: linear-gradient(133deg, #00AFFF 0%, #0F5FFF 100%) rgba(0,0,0,0);
    padding: 5px 16px;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 22px;
    border-radius: 6px;
    cursor: pointer;
    text-align: center;
}
.m1_Apple {
    background: #F2F3F5;
    padding: 5px 16px;
    border-radius: 6px;
    font-size: 14px;
    color: #1D2129;
    line-height: 22px;
    margin-left: 20px;
    cursor: pointer;
    text-align: center;
}
.m1_close {
    position: absolute;
    right: 16px;
    top: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.m1_imgView {
    display: none;
    position: fixed;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 99999999;
    background: rgba(255, 255, 255, 0.8);
    overflow: auto;
    -webkit-box-align: center;
    -webkit-box-pack: center;
}
.m1_imgView img {
    border-radius: 8px;
    width: 400px;
    cursor: zoom-out;
}
</style>